import gql from "graphql-tag";

export const GET_PRO_HEALTH_APPOINTMENTS = gql`
  query getAllProhealthAppointments($patientId: ID!, $mobileNumber: String) {
    getAllProhealthAppointments(
      patientId: $patientId
      mobileNumber: $mobileNumber
    ) {
      upcoming {
        appointmentEndDateTimeUTC
        appointmentStartDateTimeUTC
        prohealthPackage {
          packageName
        }
        displayId
        status
        shortHraLink
        bookingSource
        patientObj {
          lastName
          firstName
          dateOfBirth
          dateOfBirth
        }
        prohealthHospital {
          prohealthCity {
            cityName
          }
          unitName
          unitType
        }
      }
      previous {
        appointmentEndDateTimeUTC
        appointmentStartDateTimeUTC
        prohealthPackage {
          packageName
        }
        displayId
        status
        shortHraLink
        bookingSource
        patientObj {
          lastName
          firstName
          dateOfBirth
          dateOfBirth
        }
        prohealthHospital {
          prohealthCity {
            cityName
          }
          unitName
          unitType
        }
      }
    }
  }
`;

export const GET_PRO_HEALTH_CITIES = gql`
  query getProHealthCities {
    getProHealthCities {
      cityList {
        cityName
        id
        regionId
      }
    }
  }
`;

export const GET_PRO_HEALTH_CLINICS = gql`
  query getProHealthHospitalByCityId($cityId: ID!) {
    getProHealthHospitalByCityId(cityId: $cityId) {
      hospitals {
        unitName
        slugName
        id
        unitLocationId
        unitType
      }
    }
  }
`;

export const GET_PRO_HEALTH_PACKAGES = gql`
  query getProHealthPackageCategories($hospitalId: ID!) {
    getProHealthPackageCategories(hospitalId: $hospitalId) {
      packageCategoriesList {
        categoryName
        id
        minimumAgeInYears
        description
        genderRecomended
        image
        displayOrder
        packages {
          packageName
          id
          gender
          prohealthInclusion {
            inclusion
            inclusionParameters
          }
          price
          description
          fasting
          faqs {
            question
            answer
          }
          serviceId
          prohealthHospital {
            unitName
            slugName
            id
            prohealthCity {
              cityName
            }
          }
          isClinicPackage
          isBookable
        }
        slugName
      }
    }
  }
`;

export const GET_PROHEALTH_PACKAGES_FOR_HOSPITALS = gql`
  query getProHealthPackageCategoriesHospitals(
    $hospitalName: String!
    $cityName: String!
  ) {
    getProHealthPackageCategoriesHospitals(
      hospitalName: $hospitalName
      cityName: $cityName
    ) {
      packageCategoriesList {
        id
        PackagePrice
        PackageServiceName
        description
        Gender
        FromAge
        icon
        image
        isBookable
        packageSlugName
        hospitalSlugName
        cityName
        category
        tags {
          categoryTag {
            icon
            text
            textColor
            bgColor
          }
          customizableTag {
            icon
            text
            textColor
            bgColor
          }
        }
      }
    }
  }
`;

export const GET_PROHEALTH_PACKAGE_DETAILS_FOR_HOSPITALS = gql`
  query getProHealthHospitalPackageDetails(
    $hospitalSlugName: String
    $categorySlugName: String
    $cityName: String
  ) {
    getProHealthHospitalPackageDetails(
      hospitalSlugName: $hospitalSlugName
      categorySlugName: $categorySlugName
      cityName: $cityName
    ) {
      priceComparisionList {
        hospitalSlugName
        price
        cityName
        hospitalName
        categorySlugName
      }
      packageCategoriesList {
        hospitalId
        benefits
        categoryName
        description
        disclaimer
        genderRecomended
        image
        inclusionsCount
        minimumAgeInYears
        Hospitalname
        CityName
        PackageServiceName
        displayOrder
        tags {
          categoryTag {
            icon
            text
            textColor
            bgColor
          }
          customizableTag {
            icon
            text
            textColor
            bgColor
          }
        }
        programFeatures {
          IncluDisgnostic
          IncluDocConsultation
          IncluPersonalizedHRA
          IncluAIPowered
          IncluPathWellness
          IncluDigitalHealthRec
        }
        packages {
          fasting
          faqs {
            question
            answer
          }
          description
          isBookable
          isClinicPackage
          price
          serviceId
          gender
          packageName
        }
      }
    }
  }
`;

export const GET_PRO_HEALTH_SLOTS = gql`
  query getProhealthHospitalSlots(
    $hospitalId: Int
    $appointementDateUTC: Date!
    $packageId: Int
  ) {
    getProhealthHospitalSlots(
      hospitalId: $hospitalId
      appointementDateUTC: $appointementDateUTC
      packageId: $packageId
    ) {
      slotsinIST
    }
  }
`;

export const PRO_HEALTH_BOOKING = gql`
  mutation bookProhealthAppointment($appointmentInputs: AppointmentInputs) {
    bookProhealthAppointment(appointmentInputs: $appointmentInputs) {
      displayId
      status
    }
  }
`;

export const BOOK_PROHEALTH_HOSPITAL = gql`
  mutation bookProhealthAppointmentHospital(
    $appointmentInputs: AppointmentInputsHospital
  ) {
    bookProhealthAppointmentHospital(appointmentInputs: $appointmentInputs) {
      status
      displayId
    }
  }
`;

export const GET_PRO_HEALTH_ORDER_DATA = gql`
  query getAllProhealthOrdersByOrderIdOrDisplayId($displayId: ID) {
    getAllProhealthOrdersByOrderIdOrDisplayId(displayId: $displayId) {
      appointments {
        appointmentStartDateTimeUTC
        appointmentEndDateTimeUTC
        status
        displayId
        price
        bookingSource
        packageCategoryId
        shortHraLink
        patientObj {
          firstName
          lastName
          emailAddress
          dateOfBirth
          mobileNumber
          uhid
          gender
        }
        prohealthPackage {
          packageName
          id
          isClinicPackage
        }
        prohealthHospital {
          unitName
          unitType
          prohealthCity {
            cityName
          }
        }
      }
    }
  }
`;

export const GET_PRO_HEALTH_PACKAGE_BY_SLUG_NAME = gql`
  query getProHealthPackageBySlug(
    $categorySlugName: String!
    $hospitalSlugName: String!
    $cityName: String!
  ) {
    getProHealthPackageBySlug(
      categorySlugName: $categorySlugName
      hospitalSlugName: $hospitalSlugName
      cityName: $cityName
    ) {
      priceComparisionList {
        hospitalSlugName
        price
        cityName
        hospitalName
        categorySlugName
      }
      packageCategoriesList {
        id
        categoryName
        minimumAgeInYears
        genderRecomended
        description
        benefits
        slugName
        disclaimer
        packages {
          id
          price
          packageName
          gender
          description
          faqs {
            question
            answer
          }
          fasting
          prohealthInclusion {
            inclusion
            inclusionParameters
            helpText
          }
          serviceId
          prohealthHospital {
            unitName
            id
            prohealthCity {
              cityName
              id
            }
          }
          isClinicPackage
          isBookable
        }
        displayOrder
        image
        inclusionsCount
        tags {
          categoryTag {
            icon
            text
            textColor
            bgColor
          }
          customizableTag {
            icon
            text
            textColor
            bgColor
          }
        }
      }
    }
  }
`;

export const GET_PRO_HEALTH_CLINIC_SLOTS = gql`
  query getProhealthClinicSlots(
    $hospitalId: String!
    $appointmentDate: Date!
    $packageId: ID!
  ) {
    getProhealthClinicSlots(
      hospitalId: $hospitalId
      appointmentDate: $appointmentDate
      packageId: $packageId
    ) {
      clinicSlots {
        hcSlots {
          SlotId
          SlotTime
        }
      }
    }
  }
`;

export const GET_PRO_HEALTH_CLINIC_DATES = gql`
  query getProhealthClinicDates(
    $hospitalId: ID!
    $packageId: ID!
    $unitType: ProhealthUnitType
  ) {
    getProhealthClinicDates(
      hospitalId: $hospitalId
      packageId: $packageId
      unitType: $unitType
    ) {
      avaialbleDates
      message
    }
  }
`;

export const GET_PROHEALTH_COORDS = gql`
  query getProHealthLocationCoordinates {
    getLocationCoordinates {
      coordinates {
        latitude
        location
        longitude
      }
    }
  }
`;

export const GET_PROHEALTH_PACAKGES_BY_CITY = gql`
  query getProHealthPackageCategoriesByCity($cityName: String!) {
    getProHealthPackageCategoriesByCity(cityName: $cityName) {
      packageCategoriesListClinics {
        categoryName
        id
        minimumAgeInYears
        description
        genderRecomended
        image
        displayOrder
        packages {
          packageName
          id
          gender
          prohealthInclusion {
            inclusion
            inclusionParameters
          }
          price
          description
          fasting
          faqs {
            question
            answer
          }
          serviceId
          prohealthHospital {
            unitName
            slugName
            id
            prohealthCity {
              cityName
            }
          }
          isClinicPackage
          isBookable
        }
        slugName
        tags {
          categoryTag {
            icon
            text
            textColor
            bgColor
          }
          customizableTag {
            icon
            text
            textColor
            bgColor
          }
        }
      }
      packageCategoriesListHospitals {
        id
        PackagePrice
        PackageServiceName
        description
        Gender
        FromAge
        icon
        image
        isBookable
        packageSlugName
        hospitalSlugName
        unitName
        cityName
        category
        tags {
          categoryTag {
            icon
            text
            textColor
            bgColor
          }
          customizableTag {
            icon
            text
            textColor
            bgColor
          }
        }
      }
    }
  }
`;
